import { createContext, useContext, useState } from 'react';

const ArretTravailFormContext = createContext<any>({
    loading: false,
    setLoading: () => {},
    store: 0,
    setStore: () => {},
    activeStep: 0,
    setActiveStep: () => {},
    isModalAddEts: 0,
    setIsModalAddEts: () => {},
    stepFailed: null,
    setStepFailed: () => {},
    ficheParametrage: null,
    setFicheParametrage: () => {},
    fileList: null,
    setFileList: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function ArretTravailFormProvider({ children }: Props) {
    const [loading, setLoading] = useState<boolean>(false);
    const [store, setStore] = useState();
    const [activeStep, setActiveStep] = useState<number>(2);
    const [isModalAddEts, setIsModalAddEts] = useState(false);
    const [stepFailed, setStepFailed] = useState(null);
    const [ficheParametrage, setFicheParametrage] = useState([]);
    const [fileList, setFileList] = useState([]);

    return (
        <ArretTravailFormContext.Provider
            value={{
                loading,
                setLoading,
                store,
                setStore,
                activeStep,
                setActiveStep,
                isModalAddEts,
                setIsModalAddEts,
                stepFailed,
                setStepFailed,
                ficheParametrage,
                setFicheParametrage,
                fileList,
                setFileList,
            }}
        >
            {children}
        </ArretTravailFormContext.Provider>
    );
}

export const useArretTravailFormContext = () => useContext(ArretTravailFormContext);
